import { render } from "./PERCENT.vue?vue&type=template&id=146ce758&scoped=true"
import script from "./PERCENT.vue?vue&type=script&lang=js"
export * from "./PERCENT.vue?vue&type=script&lang=js"

import "./PERCENT.vue?vue&type=style&index=0&id=146ce758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146ce758"]])

export default __exports__